// src/component/admin/AdminLayout.js
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Outlet } from 'react-router-dom';
import AdminHeader from './header/AdminHeader';
import AdminSidebar from './header/AdminSidebar';
import AdminFooter from './header/AdminFooter';
import { AdminSidebarContext } from './AdminLayoutContext';
import './admin-layout.css';

const ADMIN_STYLE_IDS = ['admin-gentelella-style', 'admin-gentelella-responsive'];

const AdminLayout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    if (typeof document === 'undefined') return false;
    return document.body.classList.contains('nav-sm');
  });

  useEffect(() => {
    const base = process.env.PUBLIC_URL || '';
    const sheets = [
      { id: ADMIN_STYLE_IDS[0], href: `${base}/admin/css/style.css` },
      { id: ADMIN_STYLE_IDS[1], href: `${base}/admin/css/responsive.css` },
    ];
    sheets.forEach(({ id, href }) => {
      if (!document.getElementById(id)) {
        const link = document.createElement('link');
        link.id = id;
        link.rel = 'stylesheet';
        link.href = href;
        document.head.appendChild(link);
      }
    });
    return () => {
      sheets.forEach(({ id }) => document.getElementById(id)?.remove());
    };
  }, []);

  useEffect(() => {
    document.body.classList.toggle('nav-md', !sidebarCollapsed);
    document.body.classList.toggle('nav-sm', sidebarCollapsed);
  }, [sidebarCollapsed]);

  useEffect(() => {
    return () => {
      document.body.classList.remove('nav-sm');
      document.body.classList.add('nav-md');
    };
  }, []);

  const toggleSidebar = useCallback(() => {
    setSidebarCollapsed((c) => !c);
  }, []);

  const ctx = useMemo(
    () => ({ sidebarCollapsed, toggleSidebar }),
    [sidebarCollapsed, toggleSidebar]
  );

  return (
    <AdminSidebarContext.Provider value={ctx}>
      <div className="container body min-h-screen bg-slate-100 transition-colors dark:bg-slate-950">
        <div className="main_container min-h-screen">
          <AdminSidebar />
          <AdminHeader />
          <Outlet />
          <AdminFooter />
        </div>
      </div>
    </AdminSidebarContext.Provider>
  );
};

export default AdminLayout;
